<div class="eventq-protocol-action-section__shell">
  @if (showHeader()) {
    <header
      class="eventq-protocol-action-section__header"
      [class.eventq-protocol-action-section__header--current]="state() === 'current'"
      [class.eventq-protocol-action-section__header--in-progress]="state() === 'current'"
      [class.eventq-protocol-action-section__header--next]="state() === 'next'"
      [class.eventq-protocol-action-section__header--submitted]="state() === 'submitted'"
      [class.eventq-protocol-action-section__header--skipped]="state() === 'skipped'"
    >
      <h3 class="eventq-protocol-action-section__title">{{ title() }}</h3>
    </header>
  }

  @if (isSkeleton()) {
    @if (isAdditionalInformationSkeleton()) {
      <div
        class="eventq-protocol-action-section__skeleton eventq-protocol-action-section__skeleton--additional"
        aria-hidden="true"
      >
        <div class="eventq-protocol-action-section__skeleton-field">
          <span class="eventq-protocol-action-section__skeleton-label">Additional Information</span>
          <div class="eventq-protocol-action-section__skeleton-block eventq-protocol-action-section__skeleton-block--remarks"></div>
        </div>
        <div class="eventq-protocol-action-section__skeleton-field">
          <span class="eventq-protocol-action-section__skeleton-label">Review Remarks</span>
          <div class="eventq-protocol-action-section__skeleton-block eventq-protocol-action-section__skeleton-block--remarks"></div>
        </div>
      </div>
    } @else {
      <div class="eventq-protocol-action-section__skeleton" aria-hidden="true">
        <div
          class="eventq-protocol-action-section__skeleton-block eventq-protocol-action-section__skeleton-block--wide"
        ></div>
        <div class="eventq-protocol-action-section__skeleton-row">
          <div class="eventq-protocol-action-section__skeleton-block"></div>
          <div class="eventq-protocol-action-section__skeleton-block"></div>
        </div>
        <div
          class="eventq-protocol-action-section__skeleton-block eventq-protocol-action-section__skeleton-block--tall"
        ></div>
      </div>
    }
  } @else {
    <ng-content />
  }
</div>
